var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Part3"},[_c('div',{staticClass:"w"},[_c('div',{staticClass:"titleBlack"},[_c('div',[_vm._v("集成化的产品运营支撑系统")]),_c('div',{staticClass:"tipBlack"},[_vm._v("除了技术产品，一村还搭建了集产品、运营与一体的数字化监控平台")])]),_c('img',{attrs:{"src":require("@/assets/image/solution/safe/part3@2x.png"),"alt":""}})])])
}]

export { render, staticRenderFns }